import { History } from "history";
import React, { FunctionComponent, ReactNode, useEffect, useState } from "react";
import RouterContext, { RouterContextType } from "../context";
import { extractQueryParams } from "../utils";

interface Props {
  children: ReactNode;
  history: History;
}

const Router: FunctionComponent<Props> = ({ children, history }) => {
  const [state, setState] = useState<RouterContextType>({
    history,
    path: window.location.pathname,
    query: window.location.search,
    queryParams: extractQueryParams(window.location.search),
  });

  useEffect(() => {
    const unlisten = history.listen(({ location }) => {
      setState({
        history,
        path: location.pathname,
        query: location.search,
        queryParams: extractQueryParams(location.search),
      });
    });

    return () => unlisten();
  }, [history, setState]);

  return <RouterContext.Provider value={state}>{children}</RouterContext.Provider>;
};

export default Router;
